export default __webpack_public_path__ + "static/background-45f331b8401fd2f94a87c5ea75b7aa2c.jpg";